import { Component, Input } from '@angular/core';

// this component is a dummy component, used for tests. This component should only
// be used in tests.
@Component({
    selector: 'pace-core-test',
    templateUrl: './mock.component.html',
    standalone: false,
})
export class MockComponent {
    @Input()
    public template: string;
}
